/* The CaliGlow landing page: the finder, the grid chips, the jump links, the sticky bar.
 *
 * Each picker block renders the SKU map (snippets/aps-lp-skus.liquid) inside its own root and
 * carries its labels as data- attributes; the decision trees live here because their answers
 * are accuracy guardrails from the manufacturer's cross reference, and a change to them should
 * be a pull request (docs/decisions/2026-09-16-caliglow-landing-page.md).
 *
 * The matched cards are built in the shape of snippets/aps-product-card.liquid so they take
 * the collection card's own styles; the add is a real form to /cart/add with a _fit_finder
 * line property, and the In Your Hands line is <aps-when>, which reads its SKU when it
 * connects (assets/aps-when.js). Events go out through Shopify.analytics.publish for a custom
 * pixel to read; nothing third party.
 *
 * One function scope, a classic script, like the others on this theme.
 */
(() => {
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m4.8 12.4 4.9 4.9L19.2 6.9"/></svg>';
  var ALERT = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v4.5M12 16h.01"/></svg>';
  var BOLT = '<svg viewBox="0 0 20 24" aria-hidden="true"><path d="M12.6 1 2.5 13.6h6.2L6.9 23l10.6-13.3h-6.3z"/></svg>';
  var PROTO = { P: 'Pentair IntelliBrite', J: 'Jandy WaterColors', H: 'Hayward ColorLogic' };

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(cents) { var d = Math.floor(cents / 100), c = cents % 100; return '$' + d.toLocaleString() + '<sup>' + (c < 10 ? '0' : '') + c + '</sup>'; }
  function publish(name, payload) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload || {}); } catch (e) { /* analytics never breaks the page */ }
  }
  function go(id) {
    var t = document.getElementById(id);
    if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* jump links: the hero buttons, the sticky bar, the copy's link */
  document.querySelectorAll('[data-lp-go]').forEach(function (a) {
    a.addEventListener('click', function (ev) { ev.preventDefault(); go(a.dataset.lpGo); });
  });

  /* the grid chips: series or cord, one at a time */
  document.querySelectorAll('[data-lp-fil]').forEach(function (fil) {
    var grid = fil.parentElement.querySelector('[data-lp-grid]'); if (!grid) return;
    fil.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      fil.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      var f = b.dataset.f, kind = f.charAt(0), val = f.slice(2);
      grid.querySelectorAll('.lp-gi').forEach(function (w) {
        var hide = f && ((kind === 's' && w.dataset.s !== val) || (kind === 'c' && w.dataset.c !== val));
        w.hidden = !!hide;
      });
      publish('caliglow_grid_filter', { filter: f });
    });
  });

  /* a matched card, in the collection card's shape */
  function card(root, k, note, fits) {
    var L = root.dataset, free = +L.freeCents > 0 && k.price >= +L.freeCents;
    var when = k.sku ? '<aps-when class="when-line pc-when" data-sku="' + esc(k.sku) + '" data-channel="' + esc(L.channel || '16') + '">' +
      '<span class="tier" data-aps-tier data-free="' + free + '" hidden>' + BOLT + '<b data-aps-tier-label></b></span>' +
      '<span class="when-text"><span class="when-pre">' + esc(L.whenLabel || 'Delivery') + '</span> <b data-aps-when-date></b></span></aps-when>' : '';
    var av = k.avail ? '<span class="in">' + CHECK + esc(L.inLabel || 'In stock') + '</span>' : '<span class="no">' + ALERT + esc(L.outLabel || 'Out of stock') + '</span>';
    return '<div class="aps-frame aps-collection aps-card-scope"><article class="pc' + (k.avail ? '' : ' oos') + '">' +
      '<div class="im">' + (k.img ? '<img src="' + esc(k.img) + '" alt="" width="210" height="210" loading="lazy">' : '') + '</div>' +
      '<div class="bd">' + esc(k.vendor || '') + '</div>' +
      '<a class="ti" href="' + esc(k.url) + '">' + esc(k.title) + '</a>' +
      (k.mpn ? '<div class="sk">MPN ' + esc(k.mpn) + '</div>' : '') +
      '<div class="pz"><span class="now">' + money(k.price) + '</span></div><div class="sv"></div>' +
      (k.avail ? when : '') +
      '<div class="av">' + av + '</div>' +
      (note ? '<div class="note">' + note + '</div>' : '') +
      '<div class="acts"><a class="btn ghost" href="' + esc(k.url) + '">' + esc(L.moreLabel || 'More info') + '</a>' +
      (k.vid ? '<form action="/cart/add" method="post" class="pc-add"><input type="hidden" name="id" value="' + esc(k.vid) + '"><input type="hidden" name="quantity" value="1">' +
        '<input type="hidden" name="return_to" value="' + esc(L.return || '/') + '">' + (fits ? '<input type="hidden" name="properties[_fit_finder]" value="' + esc(fits) + '">' : '') +
        '<button type="submit"' + (k.avail ? '' : ' disabled') + '>' + esc(k.avail ? (L.addLabel || 'Add to cart') : (L.outLabel || 'Out of stock')) + '</button></form>' : '') +
      '</div></article></div>';
  }
  function callCard(root, title, body) {
    var phone = root.dataset.phone || '';
    return '<div class="call"><b>' + esc(title) + '</b><p>' + esc(body) + '</p>' + (phone ? '<a class="lp-btn blue" href="tel:+1' + phone.replace(/\D/g, '') + '">Call ' + esc(phone) + '</a>' : '') + '</div>';
  }
  /* The genuine replacements for a light CaliGlow does not replace: the block's product list,
     rendered by snippets/aps-lp-skus.liquid. They were a list typed in here, with no photo and
     the prices as numbers; the cards read the products now. More info only, as before. */
  function nofitCards(root) {
    var alts = [];
    try { alts = JSON.parse((root.querySelector('[data-aps-lp-alts]') || {}).textContent || '[]'); } catch (e) { alts = []; }
    var h = callCard(root, 'CaliGlow does not replace the ColorLogic 320 or 160', 'They seal into bare pipe with a compression gasket the H-Series does not have. The genuine replacement is the right answer, and we carry it.');
    alts.forEach(function (k) { h += card(root, { url: k.url, title: k.title, price: k.price, sku: k.sku, mpn: k.mpn, vendor: k.vendor, avail: k.avail, img: k.img }, '', ''); });
    return h;
  }

  /* shared picker plumbing */
  function finder(root, first, onAnswer) {
    var screen = first, step = 1, total = 3, history = [], map = [];
    try { map = JSON.parse((root.querySelector('[data-aps-lp-skus]') || {}).textContent || '[]'); } catch (e) { map = []; }
    /* The counter's words: "Step [n] of [total]" on the block that can run to four steps, or the
       older "Step 1 of 3" text, where only the step is swapped. */
    var stepTpl = root.dataset.stepTpl || (root.querySelector('[data-p-text]') || {}).textContent || 'Step 1 of 3';
    function draw() {
      var done = step === 'done';
      root.querySelectorAll('.lp-scr').forEach(function (x) { x.classList.toggle('on', x.dataset.scr === screen); });
      root.querySelectorAll('.lp-prog i').forEach(function (i) { i.hidden = +i.dataset.p > total; i.classList.toggle('on', done || +i.dataset.p <= step); });
      var t = root.querySelector('[data-p-text]'); if (!t) return;
      if (done) t.textContent = 'Done';
      else if (stepTpl.indexOf('[n]') >= 0) t.textContent = stepTpl.replace('[n]', String(step)).replace('[total]', String(total));
      else t.textContent = stepTpl.replace(/\d+(?= of)/, String(step));
    }
    var api = {
      map: map,
      find: function (s, c) { return map.filter(function (k) { return k.s === s && (!c || String(k.c) === String(c)); }); },
      total: function (n) { total = n; },
      show: function (n, at) {
        history.push({ n: screen, step: step }); screen = n; step = at; draw();
        publish('caliglow_finder_step', { finder: root.dataset.lpFinder, screen: n, step: at === 'done' ? total + 1 : at });
      },
      paint: function (h, sub, cards) {
        root.querySelector('[data-r-h]').textContent = h;
        root.querySelector('[data-r-sub]').textContent = sub.filter(Boolean).join(' · ');
        root.querySelector('[data-r-cards]').innerHTML = cards;
        api.show('result', 'done');
        publish('caliglow_finder_result', { finder: root.dataset.lpFinder, heading: h, answers: sub.filter(Boolean).join(' | ') });
      }
    };
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      /* Back restores the screen and its step. It used to pop the stack twice, which only worked
         while no path was deeper than three screens; the one finder runs to four. */
      if (b.hasAttribute('data-back')) { var prev = history.pop() || { n: first, step: 1 }; screen = prev.n; step = prev.step; if (screen === first) total = 3; draw(); return; }
      if (b.hasAttribute('data-restart')) { history = []; screen = first; step = 1; total = 3; draw(); onAnswer('__reset'); publish('caliglow_finder_step', { finder: root.dataset.lpFinder, screen: first, step: 1 }); return; }
      var a = b.dataset.a; if (!a) return;
      publish('caliglow_finder_answer', { finder: root.dataset.lpFinder, screen: b.closest('.lp-scr').dataset.scr, answer: a });
      onAnswer(b.closest('.lp-scr').dataset.scr, a, api);
    });
    root.addEventListener('submit', function (e) {
      var f = e.target.closest('form.pc-add'); if (!f) return;
      publish('caliglow_add', { finder: root.dataset.lpFinder, variant: (f.querySelector('[name=id]') || {}).value });
    });
    return api;
  }
  function cardsFor(root, api, seriesList, cord, fits, noteFor) {
    var cords = cord === 'any' ? ['50', '100', '150'] : [String(cord)];
    if (seriesList.length > 1 && cords.length > 1) cords = ['100'];
    var html = '', missing = [];
    seriesList.forEach(function (s) {
      cords.forEach(function (c) {
        var ks = api.find(s, c);
        if (!ks.length) { missing.push(s + ' ' + c + ' ft'); return; }
        ks.forEach(function (k) { html += card(root, k, noteFor ? noteFor(s) : '', fits); });
      });
    });
    if (!html) html = callCard(root, 'We will match this one by hand', 'The ' + missing.join(', ') + ' is not on the shelf right now. Call us and we will tell you when it is, or what fits in its place.');
    return html;
  }

  /* 1. the needs finder */
  document.querySelectorAll('[data-lp-finder="needs"]').forEach(function (root) {
    var st = {};
    var CTRL = { P: 'Pentair automation', J: 'Jandy automation', H: 'Hayward automation', switch: 'a plain switch', notsure: 'controller not known' };
    var WALL = { globrite: 'a GloBrite twist-lock niche', thread: 'a threaded fitting with 7 inches behind it', shallow: 'a threaded fitting under 7 inches or not measured', trufit: 'a Jandy TruFit bubbler', colorvision: 'a Pentair ColorVision bubbler', pipe: 'bare pipe, no threads' };
    function decide() {
      var s = st.ctrl, w = st.wall, series = [], call = null, nofit = false;
      if (w === 'pipe') nofit = true;
      else if (w === 'shallow') call = ['We want to check the clearance first', 'Under 7 inches behind the fitting the body will not seat, and an unmeasured MicroBrite swap is the one install we will not guess at. Measure with us on the phone, or send a photo, and we will answer in two minutes.'];
      else if (w === 'globrite' || w === 'colorvision') { if (s === 'P' || s === 'switch' || s === 'notsure') series = ['P']; else call = [(w === 'globrite' ? 'A GloBrite niche' : 'A ColorVision bubbler') + ' takes the P body', 'Your controller speaks ' + PROTO[s] + ', and the P-Series speaks Pentair. Let us look at the options with you before you order.']; }
      else if (w === 'trufit') { if (s === 'J' || s === 'H') series = [s]; else if (s === 'P') call = ['A TruFit bubbler takes the Jandy body', 'The P-Series has locking tabs that stop it seating in a TruFit, and the J and H speak Jandy or Hayward, not Pentair. Two minutes on the phone sorts out which way to go.']; else series = ['J', 'H']; }
      else { if (s === 'P' || s === 'J' || s === 'H') series = [s]; else series = ['P', 'J', 'H']; }
      return { series: series, call: call, nofit: nofit };
    }
    function result(api) {
      var d = decide(), h = 'Your matched lights', sub = [CTRL[st.ctrl], WALL[st.wall]], cards = '';
      if (d.nofit) { h = 'Not a supported fit'; cards = nofitCards(root); }
      else if (d.call) { h = 'Let us confirm this one'; cards = callCard(root, d.call[0], d.call[1]); }
      else {
        sub.push(st.cord === 'any' ? 'cord length to be measured' : st.cord + ' ft run');
        cards = cardsFor(root, api, d.series, st.cord, sub.filter(Boolean).join(' | '), null);
        if (d.series.length > 1) h = 'On a switch every series works: match the light you are replacing';
        else if (st.cord === 'any') h = 'Your ' + d.series[0] + '-Series, in all three cord lengths';
      }
      api.paint(h, sub, cards);
    }
    finder(root, 'ctrl', function (scr, a, api) {
      if (scr === '__reset') { st = {}; return; }
      if (scr === 'ctrl') { st.ctrl = a; return api.show('wall', 2); }
      if (scr === 'wall') { st.wall = a; if (a === 'pipe' || a === 'shallow') { st.cord = null; return result(api); } return api.show('cord', 3); }
      if (scr === 'cord') { st.cord = a; return result(api); }
    });
  });

  /* 2. the one finder (Dylan, 2026-09-17): which light is being replaced, then what runs the
     lights, then that light's gate, the cord, the result. The light names the body that fits the
     wall; the controller has to speak the same protocol. Where the two disagree nothing is
     matched and the answer is a call, the first finder's own rule for a GloBrite niche on a
     Jandy or Hayward controller. The block is blocks/aps-lp-replace.liquid. */
  document.querySelectorAll('[data-lp-finder="replace"]').forEach(function (root) {
    var st = {};
    var HAVE = { globrite: 'replacing a Pentair GloBrite', microbrite: 'replacing a Pentair MicroBrite', hydrocool: 'replacing a Jandy HydroCool', vu: 'replacing a J&J Color Splash VU', notsure: 'light not identified' };
    var LIGHT = { globrite: 'a Pentair GloBrite', microbrite: 'a Pentair MicroBrite', vu: 'a J&J Color Splash VU' };
    var CTRL = { P: 'Pentair automation', J: 'Jandy automation', H: 'Hayward automation', switch: 'a plain switch', notsure: 'controller not known' };
    var MODE = { J: 'Jandy mode', P: 'Pentair mode', H: 'Hayward mode' };
    var NOTE = {
      globrite: '<b>Direct fit.</b> The P-Series locking tabs and dual O-rings seat in the GloBrite niche where the old light did. Same cord run, same transformer, no rewiring.',
      microbrite: '<b>Threaded fitting.</b> The P body needs 7 inches of clearance behind it, which you confirmed. It threads into the MicroBrite\u2019s 1-1/2 inch fitting.',
      vu: '<b>Same fitting.</b> Threads into the 1-1/2 inch fitting the Color Splash used.',
      hydrocool: '<b>Same body, same seat.</b> Drops into the TruFit bubbler or the threaded fitting the HydroCool used.',
      P: '<b>Threaded fitting?</b> The P body needs 7 inches of clearance behind it. GloBrite niche and ColorVision bubbler: direct fit.',
      J: '<b>Fits</b> the Jandy TruFit bubbler and any threaded 1-1/2 inch fitting.',
      H: '<b>Not for the ColorLogic 320 or 160.</b> Fits the TruFit bubbler and threaded fittings, in place of a HydroCool in Hayward mode.'
    };
    function brand(c) { return c === 'P' || c === 'J' || c === 'H'; }
    function answers() {
      var sub = [HAVE[st.have], CTRL[st.ctrl]];
      if (st.have === 'microbrite' && st.clear) sub.push('7 inches of clearance confirmed');
      if (st.have === 'hydrocool' && st.mode) sub.push(MODE[st.mode]);
      return sub;
    }
    function confirm(api, title, body, extra) {
      api.paint('Let us confirm this one', answers().concat(extra || []), callCard(root, title, body));
    }
    function series() {
      if (st.have === 'globrite' || st.have === 'microbrite' || st.have === 'vu') return ['P'];
      if (st.have === 'hydrocool') return [st.mode];
      if (st.ctrl === 'switch') return ['P', 'J', 'H'];
      return [st.ctrl];
    }
    function result(api) {
      var ss = series(), h = 'Your replacement', sub = answers();
      sub.push(st.cord === 'any' ? 'cord length to be measured' : st.cord + ' ft run');
      var cards = cardsFor(root, api, ss, st.cord, sub.filter(Boolean).join(' | '), function (s) { return NOTE[st.have === 'notsure' ? s : st.have]; });
      if (ss.length > 1) h = 'On a switch every series works: match the brand of the light you are removing';
      else if (st.cord === 'any') h = 'Your ' + ss[0] + '-Series, in all three cord lengths';
      api.paint(h, sub, cards);
    }
    finder(root, 'have', function (scr, a, api) {
      if (scr === '__reset') { st = {}; return; }
      if (scr === 'have') {
        st = { have: a };
        if (a === 'cl320') return api.paint('Not a supported fit', ['a Hayward ColorLogic 320 or 160'], nofitCards(root));
        api.total(a === 'microbrite' || a === 'hydrocool' ? 4 : 3);
        return api.show('ctrl', 2);
      }
      if (scr === 'ctrl') {
        st.ctrl = a; st.clear = false; st.mode = null;
        if (LIGHT[st.have] && brand(a) && a !== 'P') return confirm(api, 'The replacement for this light speaks Pentair', 'A CaliGlow Pro P-Series takes the place of ' + LIGHT[st.have] + ', and your controller speaks ' + PROTO[a] + '. Let us look at the options with you before you order.');
        if (st.have === 'notsure' && a === 'notsure') return confirm(api, 'Let us work it out with you', 'Without the light or the controller we would be guessing. Call us with the label on the cord at the junction box, or what is on the equipment pad, and we will name the light in two minutes.');
        if (st.have === 'microbrite') return api.show('gate-micro', 3);
        if (st.have === 'hydrocool') return api.show('gate-mode', 3);
        return api.show('cord', 3);
      }
      if (scr === 'gate-micro') {
        if (a === 'yes') { st.clear = true; return api.show('cord', 4); }
        if (a === 'no') return confirm(api, 'This install is too shallow for the P-Series', 'Under 7 inches behind the fitting the body will not seat. That is a fact about the plumbing, not the light. Call us and we will look at what does fit, or whether the fitting can be replumbed.', ['under 7 inches behind the fitting']);
        return confirm(api, 'We want to check the clearance before you order', 'A MicroBrite swap you have not measured is the one install we will not guess at. Send a photo or measure with us on the phone and we will tell you in two minutes whether the P-Series seats.', ['clearance not measured']);
      }
      if (scr === 'gate-mode') {
        if (a === 'S') return confirm(api, 'Check the part number with us first', 'A HydroCool ending in S is the Savi color series, and CaliGlow compatibility with it is unconfirmed. Read us the part number and we will tell you where it stands.', ['S suffix or unknown']);
        st.mode = a;
        if (brand(st.ctrl) && st.ctrl !== a) return confirm(api, 'The light and the controller disagree', 'Your HydroCool is in ' + MODE[a] + ' and your controller speaks ' + PROTO[st.ctrl] + '. Read us the part number and we will sort out which CaliGlow Pro to order.');
        return api.show('cord', 4);
      }
      if (scr === 'cord') { st.cord = a; return result(api); }
    });
  });

  /* the Chat button opens the chat widget (snippets/aps-chat.liquid), the same handler as
     blocks/aps-help-panel.liquid, and the same flag, so whichever loads first answers alone */
  if (!window.__apsChatBtn && document.querySelector('[data-aps-chat]')) {
    window.__apsChatBtn = true;
    var widgetOpen = function () {
      var root = document.getElementById('cs-widget-root');
      var panel = root && root.querySelector('.cs-panel');
      var bubble = root && root.querySelector('.cs-bubble');
      if (!panel || !bubble) return false;
      if (!panel.classList.contains('open')) bubble.click();
      return true;
    };
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-aps-chat]');
      if (!a) return;
      e.preventDefault();
      if (widgetOpen()) return;
      var tries = 0;
      var t = setInterval(function () {
        if (widgetOpen()) { clearInterval(t); return; }
        if (++tries > 33) { clearInterval(t); var alt = a.getAttribute('data-fallback'); if (alt) window.location.href = alt; }
      }, 150);
    });
  }

  /* the sticky bar: shown once the hero has scrolled past, hidden while a picker or the call line is on screen */
  document.querySelectorAll('[data-lp-sticky]').forEach(function (bar) {
    if (!('IntersectionObserver' in window)) return;
    var watch = [].slice.call(document.querySelectorAll('[data-sec="top"],[data-sec="finder"],[data-sec="replace"],[data-sec="pro"]'));
    var seen = {};
    function sync() { var any = watch.some(function (t) { return seen[t.dataset.sec] !== false; }); if (any) bar.setAttribute('data-off', ''); else bar.removeAttribute('data-off'); }
    var io = new IntersectionObserver(function (es) { es.forEach(function (x) { seen[x.target.dataset.sec] = x.isIntersecting; }); sync(); }, { threshold: 0.05 });
    watch.forEach(function (t) { io.observe(t); });
  });
})();
